import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=4e0a1fcc&scoped=true"
import script from "./Classify.vue?vue&type=script&lang=js"
export * from "./Classify.vue?vue&type=script&lang=js"
import style0 from "./Classify.vue?vue&type=style&index=0&id=4e0a1fcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a1fcc",
  null
  
)

export default component.exports